import { AccountsUserIdFollowDeleteInputModel } from "./DeletetInputModel"
import { httpDelete } from "../../../../../libs/http/httpDelete"

const endpointUrl = "/v2/accounts/{user_id}/follow/"

export const deleteAccountsUserIdFollow = (
  model: AccountsUserIdFollowDeleteInputModel,
): Promise<void> => {
  return httpDelete<void>(endpointUrl, model)
}
